module.exports = __webpack_public_path__ + "static/media/logo.35e3d5dc.svg";